export function getUserProfile({ axiosPrivate, token }) {
    return axiosPrivate(`/users`, {
        method: 'GET',
        headers: { authorization: `Bearer ${token}` },
    })
        .then((res) => res.data)
        .catch((error) => {
            return Promise.reject(error?.response?.data?.message ?? 'Error')
        })
}

export function updateUserProfile({ axiosPrivate, token, data }) {
    return axiosPrivate(`/users`, {
        method: 'PATCH',
        headers: { authorization: `Bearer ${token}` },
        data,
    })
        .then((res) => res.data)
        .catch((error) => {
            return Promise.reject(error?.response?.data?.message ?? 'Error')
        })
}

export function deleteUserProfile({ axiosPrivate, token }) {
    return axiosPrivate(`/users`, {
        method: 'DELETE',
        headers: { authorization: `Bearer ${token}` },
    })
        .then((res) => res.data)
        .catch((error) => {
            return Promise.reject(error?.response?.data?.message ?? 'Error')
        })
}

export function createStripePortal({ axiosPrivate, token, prevUrl }) {
    return axiosPrivate(`/stripe/create-customer-portal-session`, {
        method: 'POST',
        headers: { authorization: `Bearer ${token}` },
        data: { prevUrl },
    })
        .then((res) => res.data)
        .catch((error) => {
            return Promise.reject(error?.response?.data?.message ?? 'Error')
        })
}

export function getStripeSubscriptionData({ axiosPrivate, token }) {
    return axiosPrivate(`/stripe/get-subscriptions`, {
        method: 'GET',
        headers: { authorization: `Bearer ${token}` },
    })
        .then((res) => res.data)
        .catch((error) => {
            return Promise.reject(error?.response?.data?.message ?? 'Error')
        })
}
